import { Modal } from './modal';
import './spinner-modal.scss';
import { Typography } from '../typography/typography';

export const SpinnerModal = ({ isOpen, contentDescription }: { isOpen: boolean; contentDescription: string }) => {
  return (
    <Modal
      isOpen={isOpen}
      title={''}
      additionalText={
        <Typography type={'display-md'} className={'loading'}>
          {contentDescription}
        </Typography>
      }
      zIndex={10000}
    />
  );
};
